const transformToUpdateDietExcludedAllergensDetailsArgs = data =>
  data?.dietExcludedAllergenIds

export default transformToUpdateDietExcludedAllergensDetailsArgs
